import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './team.css';

function Teams() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/teams/mine`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTeams(res.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load teams');
      } finally {
        setLoading(false);
      }
    };

    fetchTeams();
  }, []);

  if (loading) return <div className="team-page">Loading teams...</div>;

  return (
    <div className="team-page">
      <div className="team-page-header">
        <h2>My Teams</h2>
        <Link to="/teams/new" className="button primary-button">
          Create Team
        </Link>
      </div>

      {error && <div className="error-message">{error}</div>}

      {teams.length === 0 ? (
        <div className="empty-state">No teams found. Create your first team.</div>
      ) : (
        <div className="team-grid">
          {teams.map((team) => (
            <div key={team._id} className="team-card">
              <div className="team-card-header">
                <h3>{team.name}</h3>
                <span className="team-meta">{team.vendor?.name ? `Vendor: ${team.vendor.name}` : 'Vendor: unknown'}</span>
              </div>
              <p>{team.description || 'No description provided.'}</p>
              <div className="team-members">
                <strong>Members:</strong>
                {team.members.length === 0 ? (
                  <span className="no-members">No members yet.</span>
                ) : (
                  <ul>
                    {team.members.map((member) => (
                      <li key={member._id}>{member.name} ({member.email})</li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="team-actions">
                <Link to={`/teams/${team._id}/edit`} className="button secondary-button">
                  Manage Team
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Teams;
